export default {"src":"/_next/static/media/icon-share.52d0e4a8.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};